// public/js/collection-edit-modal.js
// Gestione modale Edit meta: apertura, chiusura e salvataggio via fetch
(function(){
  const modal = document.getElementById('editMetaModal');
  if (!modal) return; // non sei creator o partial non incluso

  // Entry points
  const openBtn = document.getElementById('editMetaBtn');
  const closeBtn = modal.querySelector('[data-edit-close]');
  const cancelBtn = modal.querySelector('[data-edit-cancel]');
  const saveBtn = modal.querySelector('[data-edit-save]');
  const form = document.getElementById('editMetaForm');
  const errorsBox = document.getElementById('editMetaErrors');

  function openModal(){ modal.classList.remove('hidden'); modal.classList.add('flex'); }
  function closeModal(){ modal.classList.add('hidden'); modal.classList.remove('flex'); }

  openBtn && openBtn.addEventListener('click', openModal);
  closeBtn && closeBtn.addEventListener('click', closeModal);
  cancelBtn && cancelBtn.addEventListener('click', closeModal);

  async function save(){
    if (!form) return;
    errorsBox.classList.add('hidden');
    errorsBox.textContent = '';

    const payload = Object.fromEntries(new FormData(form).entries());
    payload.is_published = form.querySelector('input[name="is_published"]').checked ? 1 : 0;
    // M-EGI-291: checkbox non spedisce nulla se unchecked → invio esplicito 1/0 del toggle co-creatore.
    const coCreatorInput = form.querySelector('input[name="co_creator_enabled"]');
    if (coCreatorInput) {
        payload.co_creator_enabled = coCreatorInput.checked ? 1 : 0;
    }

    const csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    const url = modal.getAttribute('data-update-url');

    try {
      const res = await fetch(url, {
        method: 'PATCH',
        headers: {
          'X-CSRF-TOKEN': csrf,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });
      const data = await res.json();
      if (!res.ok || !data.success) {
        if (data && data.errors) {
          errorsBox.innerHTML = Object.values(data.errors).flat().join('<br>');
          errorsBox.classList.remove('hidden');
        }
        throw new Error((data && data.message) || 'Update failed');
      }

      // Aggiorna DOM essenziale (titolo/descrizione)
      const c = data.collection || {};
      const titleEl = document.getElementById('collection-title');
      const descEl = document.getElementById('collection-description');
      if (titleEl && c.collection_name) titleEl.textContent = c.collection_name;
      if (descEl) {
        descEl.textContent = c.description || '';
        descEl.classList.toggle('hidden', !(c.description));
      }

  // Toast ok (testo passato dal blade via data-*)
  const toast = document.createElement('div');
  toast.className = 'fixed z-50 px-4 py-2 text-sm font-medium text-white transform -translate-x-1/2 bg-emerald-600 rounded-lg bottom-4 left-1/2';
  toast.textContent = modal.getAttribute('data-toast-updated') || 'Updated';
      document.body.appendChild(toast);
      setTimeout(() => toast.remove(), 2500);
      closeModal();
    } catch (e){
      console.error('Update error', e);
    }
  }

  saveBtn && saveBtn.addEventListener('click', save);
})();

// AI Description Generator
(function () {
    const btn = document.getElementById('aiGenerateDescBtn');
    if (!btn) return;

    const textarea   = document.getElementById('descriptionTextarea');
    const statusEl   = document.getElementById('aiDescStatus');
    const warningEl  = document.getElementById('aiDescCoverageWarning');
    const iconEl     = document.getElementById('aiGenerateIcon');
    const labelEl    = document.getElementById('aiGenerateLabel');
    const aiUrl      = btn.dataset.aiUrl;
    const csrf       = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

    function setLoading(loading) {
        btn.disabled = loading;
        iconEl.textContent = loading ? 'hourglass_empty' : 'auto_awesome';
        labelEl.textContent = loading
            ? (btn.dataset.labelLoading || 'Generazione...')
            : (btn.dataset.labelDefault || 'Genera con AI');
    }

    btn.addEventListener('click', async () => {
        // Step 0: Conferma costi prima di generare
        try {
            const pricingRes = await fetch('/api/ai/features/pricing?feature_code=ai_collection_description', {
                headers: { 'Accept': 'application/json', 'X-CSRF-TOKEN': csrf },
            });
            const pricingData = await pricingRes.json();

            if (pricingData.success && pricingData.data && !pricingData.data.is_free) {
                const p = pricingData.data;
                if (!p.has_sufficient_credits) {
                    // M-EGI-418: l'avviso era italiano scritto a mano e diceva «Egili
                    // insufficienti». Il vocabolario arriva da partials/ai-feature-lang.blade.php,
                    // incluso da collections/show e show-epp: nessun ripiego, in nessuna lingua.
                    const lang = window.AiFeatureLang || {};
                    if (typeof Swal !== 'undefined') {
                        Swal.fire({
                            icon: 'error',
                            title: lang.insufficient_title,
                            html: '<p>' + lang.insufficient_message + '</p><p><strong>' + lang.label_required + ':</strong> ' + p.cost_egili + ' ' + lang.unit + '<br><strong>' + lang.label_available + ':</strong> ' + p.user_balance + ' ' + lang.unit + '</p>',
                            confirmButtonText: lang.purchase_button,
                            showCancelButton: true,
                            cancelButtonText: lang.cancel_button,
                            confirmButtonColor: '#f97316',
                        }).then(r => { if (r.isConfirmed && typeof openEgiliPurchaseModal === 'function') openEgiliPurchaseModal(); });
                    } else {
                        alert(lang.insufficient_message);
                    }
                    return;
                }
                if (typeof Swal !== 'undefined') {
                    const confirm = await Swal.fire({
                        title: p.feature_name || 'Descrizione Collection con AI',
                        html: '<div style="background:#eff6ff;border-left:4px solid #3b82f6;padding:12px;text-align:left">'
                            + '<p style="font-size:13px;color:#374151;margin:0 0 8px">Il Council NPE genererà la descrizione della collezione basandosi sulle descrizioni di tutte le opere.</p>'
                            + '<div style="display:flex;flex-direction:column;gap:4px">'
                            + '<div><span style="font-size:13px;color:#6b7280">Token AI stimati:</span> <strong>~2.000</strong></div>'
                            + '<div><span style="font-size:13px;color:#6b7280">Egili scalati:</span> <strong style="color:#1d4ed8">' + p.cost_egili + ' Egili</strong></div>'
                            + '</div>'
                            + '<p style="font-size:11px;color:#9ca3af;margin:8px 0 0">Il tuo saldo: ' + p.user_balance + ' Egili</p></div>',
                        icon: 'question',
                        showCancelButton: true,
                        confirmButtonText: 'Conferma e genera',
                        cancelButtonText: 'Annulla',
                        confirmButtonColor: '#4f46e5',
                    });
                    if (!confirm.isConfirmed) return;
                }
            }
        } catch (e) {
            console.warn('[CollectionAI] Pricing check failed, proceeding', e);
        }

        setLoading(true);
        statusEl.textContent = '';
        warningEl.classList.add('hidden');

        try {
            const res = await fetch(aiUrl, {
                method:  'POST',
                headers: {
                    'Content-Type':  'application/json',
                    'X-CSRF-TOKEN':  csrf,
                    'Accept':        'application/json',
                },
            });

            const json = await res.json();

            if (!res.ok || json.status !== 'ok') {
                statusEl.textContent = json.message || 'Errore durante la generazione.';
                statusEl.className   = 'text-xs text-red-400';
                return;
            }

            const data = json.data;
            textarea.value = data.description || '';

            if (data.has_warning) {
                warningEl.classList.remove('hidden');
            }

            statusEl.textContent = `Copertura: ${data.coverage_percent}% (${data.described_egis}/${data.total_egis} EGI descritti)`;
            statusEl.className   = data.has_warning ? 'text-xs text-amber-400' : 'text-xs text-green-400';

        } catch (e) {
            statusEl.textContent = 'Errore di rete. Riprova.';
            statusEl.className   = 'text-xs text-red-400';
        } finally {
            setLoading(false);
        }
    });
})();
